import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-web-site-settings',
  templateUrl: './web-site-settings.component.html',
  styleUrls: ['./web-site-settings.component.scss']
})
export class WebSiteSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
